import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ChartBarIcon, PlusIcon } from "@heroicons/react/24/outline";
import { HsePageChrome } from "../../../../../components/dashboard/hse/HsePageChrome";

/**
 * HSE/KS KPI Definitions - KPI definitions list
 */
export const HseKsKpiDefinitions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const headerActions = [
    {
      label: "Ny KPI",
      icon: PlusIcon,
      path: "/dashboard/hse-ks/evaluation/kpi/definitions/new",
      hidden: false,
      menu: false,
    },
  ];

  return (
    <HsePageChrome
      title="KPI Definisjoner"
      subtitle="Administrer KPI-definisjoner"
      actions={headerActions}
    >
      <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
        <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
          <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <p className="text-gray-500">KPI-definisjoner kommer snart...</p>
            </div>
          </div>
        </div>
      </div>
    </HsePageChrome>
  );
};

